const IconClipboard = props => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="16"
		height="16"
		viewBox="0 0 16 16"
		fill="none"
		{...props}
	>
		<path
			d="M14.5 2.99999V2.49999H14L5.16668 2.49999V2.16666L14 2.16666C14.4572 2.16666 14.8333 2.5428 14.8333 2.99999V10.5H14.5V2.99999ZM1.50001 13V13.5H2.00001H11.3333H11.8333V13V5.66666V5.16666H11.3333L2.00001 5.16666H1.50001V5.66666V13ZM12.1667 5.66666V13C12.1667 13.4572 11.7905 13.8333 11.3333 13.8333H2.00001C1.54282 13.8333 1.16668 13.4572 1.16668 13V5.66666C1.16668 5.20947 1.54282 4.83332 2.00001 4.83332L11.3333 4.83332C11.7905 4.83332 12.1667 5.20947 12.1667 5.66666Z"
			fill="currentColor"
			stroke="currentColor"
		/>
	</svg>
);

export default IconClipboard;
